export enum ImageStyle {
  Fixed = "fixed",
  Full = "full",
}
